import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { getPin, setPin } from "@/lib/pin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PinGate = ({ children }) => {
  const [ok, setOk] = useState(() => Boolean(getPin()));
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onInvalid = () => setOk(false);
    window.addEventListener("cmm-pin-invalid", onInvalid);
    return () => window.removeEventListener("cmm-pin-invalid", onInvalid);
  }, []);

  if (ok) return children;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API}/verifica-pin`, { method: "POST", headers: { "X-Access-Code": code.trim() } });
      if (res.status === 401) throw new Error("Codice non valido");
      if (res.status === 429) throw new Error("Troppi tentativi: riprova tra qualche minuto");
      if (!res.ok) throw new Error("Server non raggiungibile");
      setPin(code.trim());
      setOk(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen grid place-items-center px-5">
      <form onSubmit={submit} className="card p-8 sm:p-10 w-full max-w-md fade-up" data-testid="pin-gate">
        <div className="w-14 h-14 rounded-2xl bg-[#2D4030] text-[#FAF6F0] grid place-items-center mb-6"><Lock size={24} /></div>
        <p className="eyebrow">Area del consulente</p>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#2C221E] mt-2">Codice di accesso</h1>
        <p className="text-[#5C4D46] mt-3">Inseriscilo una volta sola su questo tablet: protegge le funzioni AI e l'invio email.</p>
        <input type="password" inputMode="numeric" autoComplete="off" autoFocus className="field mt-6 text-2xl tracking-[0.4em] text-center" placeholder="••••••"
          value={code} onChange={(e) => setCode(e.target.value)} data-testid="pin-input" />
        {error && <p className="text-sm text-[#A83232] mt-3" data-testid="pin-error">{error}</p>}
        <button type="submit" className="btn btn-primary w-full mt-6" disabled={!code.trim() || busy} data-testid="pin-submit-btn">{busy ? "Verifica…" : "Entra"}</button>
      </form>
    </div>
  );
};
